import { render, staticRenderFns } from "./ShoppingCartCpn.vue?vue&type=template&id=519380da&scoped=true"
import script from "./ShoppingCartCpn.vue?vue&type=script&lang=js"
export * from "./ShoppingCartCpn.vue?vue&type=script&lang=js"
import style0 from "./ShoppingCartCpn.vue?vue&type=style&index=0&id=519380da&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "519380da",
  null
  
)

export default component.exports